import { API_ENDPOINTS } from "../constants/endpoints";
import { MigrateUserRequest, SuperAdminGenericResponse } from "../types/super-admin";
import { post } from "../utils/api.utils";

class SuperAdminService {
  public static async migrateUser(data: MigrateUserRequest): Promise<SuperAdminGenericResponse> {
    try {
        const response = await post<SuperAdminGenericResponse>(
            API_ENDPOINTS.SUPER_ADMIN.MIGRATE_USER,
                data
            );
        return response;
    } catch (error) {
      throw error;
    }
  }
}

export default SuperAdminService;

